'use client';

import { useLayoutEffect } from 'react';
import {
	GRID_CONFIG_VALUES,
	GridConfigValue,
} from 'src/hooks/useTradePageLayout/type';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

export default function useLayoutConfigSetting() {
	const [layoutSetting, setLayoutSetting] =
		useSyncLocalStorage<GridConfigValue>('layoutSetting2', 'default');

	useLayoutEffect(() => {
		if (!GRID_CONFIG_VALUES.includes(layoutSetting)) {
			setLayoutSetting('default');
		}
	}, [layoutSetting]);

	return [layoutSetting, setLayoutSetting] as const;
}
